import { pageState, setPageStateById } from '../PageContext';

export const resetPage = (setState: setPageStateById) => () => {
  setState('RESET_PAGE', () => ({
    ...pageState,
  }));
};
